import React, { useMemo } from "react";
import { buildFreshProductSheet, type FreshSheetPackage, type FreshSheetProduct } from "./freshProductSheet";
import ProductSheetDialog from "./ProductSheetDialog";
import { freshProductArchiveImages, type ProductExportFormat } from "./productArchive";

export default function FreshProductSheetDialog({ product, packages, products, dataReady, onClose, format }: {
  product?: FreshSheetProduct; packages: FreshSheetPackage[]; products: FreshSheetProduct[]; dataReady: boolean; onClose: () => void; format?: ProductExportFormat;
}) {
  const sheets = useMemo(() => product ? {
    sv: buildFreshProductSheet(product, packages, products, "sv"), en: buildFreshProductSheet(product, packages, products, "en"),
  } : undefined, [product, packages, products]);
  const images = useMemo(() => product ? freshProductArchiveImages(product) : [], [product]);
  return <ProductSheetDialog sheets={sheets} dataReady={dataReady} onClose={onClose} format={format} archiveImages={images} />;
}
